import { useState } from 'react';
import '@/App.css';
import { Bell, Search, Heart, MessageCircle, Share2, X, Menu, Users, Calendar, TrendingUp, Briefcase, Linkedin, MapPin, Home, UserMinus, Mail } from 'lucide-react';

// Dummy data for sustainability professionals
const MEMBER_PROFILES = [
  {
    id: 1,
    name: 'Budi Santoso',
    role: 'Sustainability Manager',
    company: 'PT Hijau Lestari',
    sector: 'Manufacturing',
    expertise: 'Carbon Accounting & ESG Reporting',
    linkedin: 'https://linkedin.com/in/budi-santoso',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Budi'
  },
  {
    id: 2,
    name: 'Siti Rahayu',
    role: 'ESG Director',
    company: 'Bank Nusantara',
    sector: 'Financial Services',
    expertise: 'Sustainable Finance & Green Bonds',
    linkedin: 'https://linkedin.com/in/siti-rahayu',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Siti'
  },
  {
    id: 3,
    name: 'Ahmad Pratama',
    role: 'Climate Change Consultant',
    company: 'GreenPath Consulting',
    sector: 'Consulting',
    expertise: 'GHG Emissions & Climate Risk Assessment',
    linkedin: 'https://linkedin.com/in/ahmad-pratama',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Ahmad'
  },
  {
    id: 4,
    name: 'Dewi Lestari',
    role: 'Circular Economy Specialist',
    company: 'PT Daur Ulang Indonesia',
    sector: 'Waste Management',
    expertise: 'Circular Economy & Waste Reduction',
    linkedin: 'https://linkedin.com/in/dewi-lestari',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Dewi'
  },
  {
    id: 5,
    name: 'Rudi Hermawan',
    role: 'Renewable Energy Engineer',
    company: 'Solar Nusantara',
    sector: 'Energy',
    expertise: 'Solar & Wind Energy Systems',
    linkedin: 'https://linkedin.com/in/rudi-hermawan',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Rudi'
  },
  {
    id: 6,
    name: 'Maya Kusuma',
    role: 'Social Impact Manager',
    company: 'Impact Indonesia Foundation',
    sector: 'Non-Profit',
    expertise: 'Social Impact Assessment & Community Development',
    linkedin: 'https://linkedin.com/in/maya-kusuma',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Maya'
  },
  {
    id: 7,
    name: 'Andi Wijaya',
    role: 'Supply Chain Sustainability Lead',
    company: 'PT Retail Modern',
    sector: 'Retail',
    expertise: 'Sustainable Supply Chain & Ethical Sourcing',
    linkedin: 'https://linkedin.com/in/andi-wijaya',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Andi'
  },
  {
    id: 8,
    name: 'Lina Permata',
    role: 'Environmental Compliance Officer',
    company: 'PT Industri Bersih',
    sector: 'Industrial',
    expertise: 'Environmental Regulations & Compliance',
    linkedin: 'https://linkedin.com/in/lina-permata',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Lina'
  },
  {
    id: 9,
    name: 'Farhan Rizki',
    role: 'Green Building Architect',
    company: 'EcoDesign Studio',
    sector: 'Architecture',
    expertise: 'Green Building Design & LEED Certification',
    linkedin: 'https://linkedin.com/in/farhan-rizki',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Farhan'
  },
  {
    id: 10,
    name: 'Nina Sari',
    role: 'Biodiversity Conservation Expert',
    company: 'Indonesia Wildlife Trust',
    sector: 'Conservation',
    expertise: 'Biodiversity Protection & Habitat Restoration',
    linkedin: 'https://linkedin.com/in/nina-sari',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Nina'
  },
  {
    id: 11,
    name: 'Hendra Gunawan',
    role: 'Water Resources Manager',
    company: 'PT Air Bersih',
    sector: 'Utilities',
    expertise: 'Water Management & Conservation',
    linkedin: 'https://linkedin.com/in/hendra-gunawan',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Hendra'
  },
  {
    id: 12,
    name: 'Rina Melati',
    role: 'Sustainability Communications Lead',
    company: 'PT Media Hijau',
    sector: 'Media & Communications',
    expertise: 'Sustainability Reporting & Stakeholder Engagement',
    linkedin: 'https://linkedin.com/in/rina-melati',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Rina'
  }
];

// Dummy data for connections
const CONNECTIONS = [
  {
    id: 2,
    name: 'Siti Rahayu',
    role: 'ESG Director',
    company: 'Bank Nusantara',
    sector: 'Financial Services',
    expertise: 'Sustainable Finance & Green Bonds',
    linkedin: 'https://linkedin.com/in/siti-rahayu',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Siti'
  },
  {
    id: 3,
    name: 'Ahmad Pratama',
    role: 'Climate Change Consultant',
    company: 'GreenPath Consulting',
    sector: 'Consulting',
    expertise: 'GHG Emissions & Climate Risk Assessment',
    linkedin: 'https://linkedin.com/in/ahmad-pratama',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Ahmad'
  },
  {
    id: 4,
    name: 'Dewi Lestari',
    role: 'Circular Economy Specialist',
    company: 'PT Daur Ulang Indonesia',
    sector: 'Waste Management',
    expertise: 'Circular Economy & Waste Reduction',
    linkedin: 'https://linkedin.com/in/dewi-lestari',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Dewi'
  },
  {
    id: 5,
    name: 'Rudi Hermawan',
    role: 'Renewable Energy Engineer',
    company: 'Solar Nusantara',
    sector: 'Energy',
    expertise: 'Solar & Wind Energy Systems',
    linkedin: 'https://linkedin.com/in/rudi-hermawan',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Rudi'
  },
  {
    id: 7,
    name: 'Andi Wijaya',
    role: 'CSR Specialist',
    company: 'Danone Indonesia',
    sector: 'Food & Beverage',
    expertise: 'Corporate Social Responsibility & Community Programs',
    linkedin: 'https://linkedin.com/in/andi-wijaya',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Andi'
  },
  {
    id: 8,
    name: 'Lina Permata',
    role: 'Environmental Compliance Officer',
    company: 'PT Industri Bersih',
    sector: 'Industrial',
    expertise: 'Environmental Regulations & Compliance',
    linkedin: 'https://linkedin.com/in/lina-permata',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Lina'
  },
  {
    id: 9,
    name: 'Farhan Rizki',
    role: 'Green Building Architect',
    company: 'EcoDesign Studio',
    sector: 'Architecture',
    expertise: 'Green Building Design & LEED Certification',
    linkedin: 'https://linkedin.com/in/farhan-rizki',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Farhan'
  },
  {
    id: 10,
    name: 'Nina Sari',
    role: 'Biodiversity Conservation Expert',
    company: 'Indonesia Wildlife Trust',
    sector: 'Conservation',
    expertise: 'Biodiversity Protection & Habitat Restoration',
    linkedin: 'https://linkedin.com/in/nina-sari',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Nina'
  },
  {
    id: 11,
    name: 'Hendra Gunawan',
    role: 'Water Resources Manager',
    company: 'PT Air Bersih',
    sector: 'Utilities',
    expertise: 'Water Management & Conservation',
    linkedin: 'https://linkedin.com/in/hendra-gunawan',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Hendra'
  },
  {
    id: 12,
    name: 'Rina Melati',
    role: 'Sustainability Communications Lead',
    company: 'PT Media Hijau',
    sector: 'Media & Communications',
    expertise: 'Sustainability Reporting & Stakeholder Engagement',
    linkedin: 'https://linkedin.com/in/rina-melati',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Rina'
  }
];

const INITIAL_POSTS = [
  {
    id: 1,
    authorId: 2,
    content: 'Exciting news! Bank Nusantara just issued Indonesia\'s largest green bond worth $500M to fund renewable energy projects across the archipelago. This is a major step forward in sustainable finance. What are your thoughts on green bonds as a financing mechanism? 🌱 #SustainableFinance #GreenBonds',
    timestamp: '2 hours ago',
    likes: 24,
    comments: []
  },
  {
    id: 2,
    authorId: 3,
    content: 'Quick question for the community: What GHG calculation tools do you recommend for mid-sized manufacturing companies? We\'re helping a client set up their first carbon inventory and looking for user-friendly options that comply with GHG Protocol standards. Any suggestions welcome! #CarbonAccounting #GHGProtocol',
    timestamp: '5 hours ago',
    likes: 18,
    comments: []
  },
  {
    id: 3,
    authorId: 5,
    content: 'Just finished installing a 2MW solar farm for a textile factory in Bandung! The system will offset 1,200 tons of CO2 annually and reduce their energy costs by 40%. Seeing more Indonesian manufacturers embrace renewable energy every day. The future is bright (and solar-powered)! ☀️ #RenewableEnergy #SolarPower',
    timestamp: '8 hours ago',
    likes: 42,
    comments: []
  },
  {
    id: 4,
    authorId: 7,
    content: 'Attended an excellent workshop on the new EU Deforestation Regulation (EUDR) today. Indonesian exporters need to prepare for due diligence requirements on palm oil, rubber, cocoa, and timber. Compliance deadline is approaching fast - Dec 2024. Is your company ready? #EUDR #SupplyChain',
    timestamp: '1 day ago',
    likes: 31,
    comments: []
  },
  {
    id: 5,
    authorId: 4,
    content: 'Proud to share that PT Daur Ulang Indonesia achieved 85% waste diversion rate last quarter! Our circular economy model is proving that zero-waste is not just a dream. Key success factors: comprehensive sorting, partnerships with recyclers, and employee engagement. Happy to share our playbook with anyone interested! #CircularEconomy #ZeroWaste',
    timestamp: '1 day ago',
    likes: 56,
    comments: []
  },
  {
    id: 6,
    authorId: 6,
    content: 'Reminder: IS2P members can now access the Social Impact Assessment Toolkit we developed with UN agencies. It includes frameworks, templates, and case studies specifically for Indonesian context. Check your member portal downloads section! #SocialImpact #CommunityDevelopment',
    timestamp: '2 days ago',
    likes: 29,
    comments: []
  },
  {
    id: 7,
    authorId: 9,
    content: 'Our latest green office building in Jakarta just received LEED Platinum certification! First in Indonesia to achieve net-zero energy consumption. Features include solar panels, rainwater harvesting, natural ventilation, and smart building systems. Architecture CAN be sustainable and beautiful. 🏢 #GreenBuilding #LEED',
    timestamp: '3 days ago',
    likes: 67,
    comments: []
  },
  {
    id: 8,
    authorId: 8,
    content: 'PSA: New Indonesian environmental regulation PP 22/2021 on wastewater management is now fully enforced. Stricter limits on BOD, COD, and heavy metals. Many companies are scrambling to upgrade treatment facilities. If you need help with compliance planning, reach out. #EnvironmentalCompliance #WaterQuality',
    timestamp: '3 days ago',
    likes: 38,
    comments: []
  },
  {
    id: 9,
    authorId: 10,
    content: 'Incredible experience leading a mangrove restoration project in Kalimantan this week. We planted 10,000 mangrove seedlings with local communities. These ecosystems are crucial for coastal protection and carbon sequestration - storing up to 4x more carbon than rainforests! 🌿 #Biodiversity #MangroveRestoration',
    timestamp: '4 days ago',
    likes: 89,
    comments: []
  },
  {
    id: 10,
    authorId: 11,
    content: 'Water stress is becoming critical in Java. Our analysis shows 40% of industrial zones facing water scarcity by 2030 if current trends continue. Companies need to invest in water efficiency, recycling, and alternative sources NOW. This isn\'t a future problem - it\'s happening today. #WaterManagement #WaterSecurity',
    timestamp: '5 days ago',
    likes: 44,
    comments: []
  },
  {
    id: 11,
    authorId: 12,
    content: 'Just published our annual Sustainability Communications Benchmark Report. Key finding: Indonesian companies that communicate ESG efforts transparently see 3x higher stakeholder trust. Authenticity matters more than perfection. Report link in comments! #SustainabilityReporting #ESGCommunications',
    timestamp: '6 days ago',
    likes: 52,
    comments: []
  }
];

function App() {
  const [currentView, setCurrentView] = useState('login');
  const [selectedUserProfile, setSelectedUserProfile] = useState(null);
  const [posts, setPosts] = useState(INITIAL_POSTS);
  const [newPostText, setNewPostText] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [connectionSearchQuery, setConnectionSearchQuery] = useState('');

  const currentUser = MEMBER_PROFILES[0];

  const handleLogin = (e) => {
    e.preventDefault();
    setCurrentView('feed');
  };

  const handleLogout = () => {
    setCurrentView('login');
    setShowDropdown(false);
  };

  const handleCreatePost = () => {
    if (newPostText.trim()) {
      const newPost = {
        id: posts.length + 1,
        authorId: currentUser.id,
        content: newPostText,
        timestamp: 'Just now',
        likes: 0,
        comments: []
      };
      setPosts([newPost, ...posts]);
      setNewPostText('');
    }
  };

  const toggleLike = (postId) => {
    setPosts(posts.map(post => {
      if (post.id === postId) {
        const isLiked = post.likedByUser;
        return {
          ...post,
          likes: isLiked ? post.likes - 1 : post.likes + 1,
          likedByUser: !isLiked
        };
      }
      return post;
    }));
  };

  const toggleComments = (postId) => {
    setPosts(posts.map(post => {
      if (post.id === postId) {
        return { ...post, showComments: !post.showComments };
      }
      return post;
    }));
  };

  const openProfile = (userId) => {
    if (userId !== currentUser.id) {
      const profile = MEMBER_PROFILES.find(p => p.id === userId);
      setSelectedUserProfile(profile);
    }
  };

  const filteredConnections = CONNECTIONS.filter(conn => {
    if (!connectionSearchQuery) return true;
    const query = connectionSearchQuery.toLowerCase();
    return (
      conn.name.toLowerCase().includes(query) ||
      conn.role.toLowerCase().includes(query) ||
      conn.company.toLowerCase().includes(query) ||
      conn.sector.toLowerCase().includes(query)
    );
  });

  if (currentView === 'login') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          <div className="bg-white rounded-2xl shadow-xl p-8">
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-emerald-600 rounded-full mb-4">
                <Users className="w-8 h-8 text-white" />
              </div>
              <h1 className="text-3xl font-bold text-slate-900 mb-2">IS2P Member Portal</h1>
              <p className="text-slate-600">Indonesian Society of Sustainability Professionals</p>
            </div>

            <form onSubmit={handleLogin} data-testid="login-form">
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">
                    Email Address
                  </label>
                  <input
                    type="email"
                    data-testid="email-input"
                    className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-shadow"
                    placeholder="your.email@company.com"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">
                    Password
                  </label>
                  <input
                    type="password"
                    data-testid="password-input"
                    className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-shadow"
                    placeholder="••••••••"
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                data-testid="login-button"
                className="w-full mt-6 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-3 rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl"
              >
                Sign In
              </button>
            </form>

            <div className="mt-6 text-center text-sm text-slate-600">
              <a href="#" className="text-emerald-600 hover:text-emerald-700 font-medium">Forgot password?</a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Top Navbar */}
      <nav className="bg-white border-b border-slate-200 sticky top-0 z-40 shadow-sm">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            {/* Left: Logo and Search */}
            <div className="flex items-center space-x-4 flex-1">
              <button
                data-testid="mobile-menu-button"
                className="lg:hidden p-2 rounded-lg hover:bg-slate-100"
                onClick={() => setShowMobileMenu(!showMobileMenu)}
              >
                <Menu className="w-6 h-6 text-slate-700" />
              </button>
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 bg-emerald-600 rounded-lg flex items-center justify-center">
                  <Users className="w-5 h-5 text-white" />
                </div>
                <span className="font-bold text-slate-900 hidden sm:block">IS2P</span>
              </div>
              <div className="hidden md:flex flex-1 max-w-md">
                <div className="relative w-full">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400" />
                  <input
                    type="text"
                    data-testid="search-input"
                    placeholder="Search members, topics..."
                    className="w-full pl-10 pr-4 py-2 bg-slate-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500"
                  />
                </div>
              </div>
            </div>

            {/* Right: Notifications and User */}
            <div className="flex items-center space-x-4">
              <button data-testid="notification-button" className="p-2 rounded-lg hover:bg-slate-100 relative">
                <Bell className="w-6 h-6 text-slate-700" />
                <span className="absolute top-1 right-1 w-2 h-2 bg-emerald-600 rounded-full"></span>
              </button>
              <div className="relative">
                <button
                  data-testid="user-menu-button"
                  onClick={() => setShowDropdown(!showDropdown)}
                  className="flex items-center space-x-2 p-1 rounded-lg hover:bg-slate-100"
                >
                  <img
                    src={currentUser.avatar}
                    alt={currentUser.name}
                    className="w-8 h-8 rounded-full"
                  />
                </button>
                {showDropdown && (
                  <div data-testid="user-dropdown" className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-xl border border-slate-200 py-2">
                    <button
                      data-testid="logout-button"
                      onClick={handleLogout}
                      className="w-full text-left px-4 py-2 hover:bg-slate-100 text-slate-700"
                    >
                      Logout
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {showMobileMenu && (
        <div className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-30" onClick={() => setShowMobileMenu(false)}>
          <div className="bg-white w-64 h-full p-4" onClick={(e) => e.stopPropagation()}>
            <div className="mb-6">
              <h3 className="font-semibold text-slate-900 mb-2">Your Profile</h3>
              <div className="flex items-center space-x-3 p-3 bg-slate-50 rounded-lg">
                <img src={currentUser.avatar} alt={currentUser.name} className="w-12 h-12 rounded-full" />
                <div>
                  <p className="font-semibold text-slate-900 text-sm">{currentUser.name}</p>
                  <p className="text-xs text-slate-600">{currentUser.role}</p>
                </div>
              </div>
            </div>
            
            {/* Navigation */}
            <div className="mb-6 space-y-1">
              <button
                onClick={() => {
                  setCurrentView('feed');
                  setShowMobileMenu(false);
                }}
                className={`w-full flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors ${
                  currentView === 'feed' 
                    ? 'bg-emerald-50 text-emerald-600' 
                    : 'text-slate-700 hover:bg-slate-100'
                }`}
              >
                <Home className="w-5 h-5" />
                <span className="font-medium">Home</span>
              </button>
              <button
                onClick={() => {
                  setCurrentView('connections');
                  setShowMobileMenu(false);
                }}
                className={`w-full flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors ${
                  currentView === 'connections' 
                    ? 'bg-emerald-50 text-emerald-600' 
                    : 'text-slate-700 hover:bg-slate-100'
                }`}
              >
                <Users className="w-5 h-5" />
                <span className="font-medium">My Network</span>
              </button>
            </div>
            
            <div className="space-y-4">
              <div>
                <h3 className="font-semibold text-slate-900 mb-2">Trending Topics</h3>
                <div className="space-y-2">
                  <div className="text-sm text-emerald-600 font-medium">#CarbonAccounting</div>
                  <div className="text-sm text-emerald-600 font-medium">#CircularEconomy</div>
                  <div className="text-sm text-emerald-600 font-medium">#ESGReporting</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Main Content - 3 Column Layout */}
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* Left Sidebar - Current User Profile */}
          <aside className="hidden lg:block lg:col-span-3">
            <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden sticky top-24">
              <div className="h-16 bg-gradient-to-r from-emerald-500 to-emerald-600"></div>
              <div className="px-4 pb-4">
                <img
                  src={currentUser.avatar}
                  alt={currentUser.name}
                  className="w-16 h-16 rounded-full border-4 border-white -mt-8 mb-3"
                />
                <h3 className="font-bold text-slate-900">{currentUser.name}</h3>
                <p className="text-sm text-slate-600 mt-1">{currentUser.role}</p>
                <p className="text-sm text-slate-600">{currentUser.company}</p>
                <div className="flex justify-around mt-4 pt-4 border-t border-slate-200">
                  <div className="text-center">
                    <p className="font-semibold text-slate-900">120</p>
                    <p className="text-xs text-slate-600">Connections</p>
                  </div>
                  <div className="text-center">
                    <p className="font-semibold text-slate-900">15</p>
                    <p className="text-xs text-slate-600">Posts</p>
                  </div>
                </div>
                
                {/* Navigation Menu */}
                <div className="mt-4 pt-4 border-t border-slate-200 space-y-1">
                  <button
                    data-testid="nav-feed-button"
                    onClick={() => setCurrentView('feed')}
                    className={`w-full flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors ${
                      currentView === 'feed' 
                        ? 'bg-emerald-50 text-emerald-600' 
                        : 'text-slate-700 hover:bg-slate-100'
                    }`}
                  >
                    <Home className="w-5 h-5" />
                    <span className="font-medium">Home</span>
                  </button>
                  <button
                    data-testid="nav-connections-button"
                    onClick={() => setCurrentView('connections')}
                    className={`w-full flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors ${
                      currentView === 'connections' 
                        ? 'bg-emerald-50 text-emerald-600' 
                        : 'text-slate-700 hover:bg-slate-100'
                    }`}
                  >
                    <Users className="w-5 h-5" />
                    <span className="font-medium">My Network</span>
                  </button>
                </div>
              </div>
            </div>
          </aside>

          {/* Main Feed */}
          <main className="lg:col-span-6">
            {currentView === 'feed' && (
              <>
                {/* Create Post Box */}
                <div data-testid="create-post-box" className="bg-white rounded-xl shadow-sm border border-slate-200 p-4 mb-4">
                  <div className="flex space-x-3">
                    <img src={currentUser.avatar} alt={currentUser.name} className="w-10 h-10 rounded-full" />
                    <div className="flex-1">
                      <textarea
                        data-testid="create-post-input"
                        value={newPostText}
                        onChange={(e) => setNewPostText(e.target.value)}
                        placeholder="Share an update, article, or ask the community..."
                        className="w-full px-4 py-3 bg-slate-50 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 resize-none"
                        rows="3"
                      />
                      <div className="flex justify-end mt-2">
                        <button
                          data-testid="create-post-button"
                          onClick={handleCreatePost}
                          disabled={!newPostText.trim()}
                          className="px-6 py-2 bg-emerald-600 hover:bg-emerald-700 disabled:bg-slate-300 disabled:cursor-not-allowed text-white font-medium rounded-lg transition-colors"
                        >
                          Post
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Feed Posts */}
                <div className="space-y-4">
                  {posts.map((post) => {
                    const author = MEMBER_PROFILES.find(p => p.id === post.authorId);
                    return (
                      <article key={post.id} data-testid={`post-${post.id}`} className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
                        {/* Post Header */}
                        <div className="flex items-start space-x-3 mb-4">
                          <img
                            src={author.avatar}
                            alt={author.name}
                            data-testid={`post-avatar-${post.id}`}
                            onClick={() => openProfile(author.id)}
                            className={`w-12 h-12 rounded-full ${author.id !== currentUser.id ? 'cursor-pointer hover:ring-2 hover:ring-emerald-500' : ''}`}
                          />
                      <div className="flex-1">
                        <h4
                          data-testid={`post-author-${post.id}`}
                          onClick={() => openProfile(author.id)}
                          className={`font-semibold text-slate-900 ${author.id !== currentUser.id ? 'cursor-pointer hover:text-emerald-600' : ''}`}
                        >
                          {author.name}
                        </h4>
                        <p className="text-sm text-slate-600">{author.role} at {author.company}</p>
                        <p className="text-xs text-slate-500 mt-1">{post.timestamp}</p>
                      </div>
                    </div>

                    {/* Post Content */}
                    <div className="mb-4">
                      <p className="text-slate-800 leading-relaxed whitespace-pre-line">{post.content}</p>
                    </div>

                    {/* Post Actions */}
                    <div className="flex items-center space-x-6 pt-4 border-t border-slate-200">
                      <button
                        data-testid={`like-button-${post.id}`}
                        onClick={() => toggleLike(post.id)}
                        className={`flex items-center space-x-2 ${post.likedByUser ? 'text-emerald-600' : 'text-slate-600'} hover:text-emerald-600 transition-colors`}
                      >
                        <Heart className={`w-5 h-5 ${post.likedByUser ? 'fill-emerald-600' : ''}`} />
                        <span className="text-sm font-medium">{post.likes} Likes</span>
                      </button>
                      <button
                        data-testid={`comment-button-${post.id}`}
                        onClick={() => toggleComments(post.id)}
                        className="flex items-center space-x-2 text-slate-600 hover:text-emerald-600 transition-colors"
                      >
                        <MessageCircle className="w-5 h-5" />
                        <span className="text-sm font-medium">Comment</span>
                      </button>
                      <button
                        data-testid={`share-button-${post.id}`}
                        className="flex items-center space-x-2 text-slate-600 hover:text-emerald-600 transition-colors"
                      >
                        <Share2 className="w-5 h-5" />
                        <span className="text-sm font-medium">Share</span>
                      </button>
                    </div>

                    {/* Comments Section */}
                    {post.showComments && (
                      <div data-testid={`comments-section-${post.id}`} className="mt-4 pt-4 border-t border-slate-200">
                        <div className="bg-slate-50 rounded-lg p-4">
                          <p className="text-sm text-slate-600 text-center">No comments yet. Be the first to comment!</p>
                        </div>
                      </div>
                    )}
                  </article>
                );
              })}
            </div>
              </>
            )}

            {currentView === 'connections' && (
            <div data-testid="connections-page">
              {/* Header Section */}
              <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-6">
                <h1 className="text-3xl font-bold text-slate-900 mb-2">My Connections</h1>
                <div className="flex items-center space-x-2 mb-4">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-emerald-100 text-emerald-700">
                    <Users className="w-4 h-4 mr-1" />
                    {CONNECTIONS.length} professionals in your network
                  </span>
                </div>
                
                {/* Search Bar */}
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400" />
                  <input
                    type="text"
                    data-testid="connections-search-input"
                    value={connectionSearchQuery}
                    onChange={(e) => setConnectionSearchQuery(e.target.value)}
                    placeholder="Search connections by name, role, or company..."
                    className="w-full pl-10 pr-4 py-3 bg-slate-50 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                  />
                </div>
              </div>

              {/* Connections Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {filteredConnections.map((connection) => (
                  <div
                    key={connection.id}
                    data-testid={`connection-card-${connection.id}`}
                    className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-shadow"
                  >
                    <div className="flex items-start space-x-4">
                      {/* Avatar */}
                      <img
                        src={connection.avatar}
                        alt={connection.name}
                        className="w-16 h-16 rounded-full flex-shrink-0"
                      />
                      
                      {/* Connection Info */}
                      <div className="flex-1 min-w-0">
                        <h3
                          data-testid={`connection-name-${connection.id}`}
                          onClick={() => openProfile(connection.id)}
                          className="text-lg font-bold text-slate-900 cursor-pointer hover:text-emerald-600 transition-colors mb-1"
                        >
                          {connection.name}
                        </h3>
                        <p className="text-sm text-slate-700 mb-1">{connection.role}</p>
                        <p className="text-sm text-slate-600 mb-2 flex items-center">
                          <Briefcase className="w-4 h-4 mr-1" />
                          {connection.company}
                        </p>
                        <p className="text-xs text-slate-500 mb-1">
                          <span className="font-medium">Sector:</span> {connection.sector}
                        </p>
                        <p className="text-xs text-slate-500">
                          <span className="font-medium">Focus:</span> {connection.expertise}
                        </p>
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="flex items-center space-x-3 mt-4 pt-4 border-t border-slate-200">
                      <button
                        data-testid={`message-button-${connection.id}`}
                        className="flex-1 flex items-center justify-center space-x-2 px-4 py-2 bg-white border-2 border-emerald-600 text-emerald-600 rounded-lg hover:bg-emerald-50 transition-colors font-medium"
                      >
                        <Mail className="w-4 h-4" />
                        <span>Message</span>
                      </button>
                      <button
                        data-testid={`disconnect-button-${connection.id}`}
                        className="p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                        title="Disconnect"
                      >
                        <UserMinus className="w-5 h-5" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              {filteredConnections.length === 0 && (
                <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-12 text-center">
                  <Users className="w-12 h-12 text-slate-300 mx-auto mb-3" />
                  <p className="text-slate-600">No connections found matching your search.</p>
                </div>
              )}
            </div>
            )}
          </main>

          {/* Right Sidebar - Widgets */}
          <aside className="hidden lg:block lg:col-span-3">
            <div className="space-y-4 sticky top-24">
              {/* Upcoming Events */}
              <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-4">
                <div className="flex items-center space-x-2 mb-4">
                  <Calendar className="w-5 h-5 text-emerald-600" />
                  <h3 className="font-semibold text-slate-900">Upcoming Events</h3>
                </div>
                <div className="space-y-3">
                  <div className="text-sm">
                    <p className="font-medium text-slate-900">IS2P Quarterly Meetup</p>
                    <p className="text-xs text-slate-600">Jan 25, 2026 • Jakarta</p>
                  </div>
                  <div className="text-sm">
                    <p className="font-medium text-slate-900">ESG Reporting Workshop</p>
                    <p className="text-xs text-slate-600">Feb 5, 2026 • Online</p>
                  </div>
                  <div className="text-sm">
                    <p className="font-medium text-slate-900">Carbon Accounting Webinar</p>
                    <p className="text-xs text-slate-600">Feb 12, 2026 • Online</p>
                  </div>
                </div>
              </div>

              {/* Trending Topics */}
              <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-4">
                <div className="flex items-center space-x-2 mb-4">
                  <TrendingUp className="w-5 h-5 text-emerald-600" />
                  <h3 className="font-semibold text-slate-900">Trending Topics</h3>
                </div>
                <div className="space-y-2">
                  <div className="text-sm">
                    <p className="font-medium text-emerald-600">#CarbonAccounting</p>
                    <p className="text-xs text-slate-600">156 posts this week</p>
                  </div>
                  <div className="text-sm">
                    <p className="font-medium text-emerald-600">#CircularEconomy</p>
                    <p className="text-xs text-slate-600">142 posts this week</p>
                  </div>
                  <div className="text-sm">
                    <p className="font-medium text-emerald-600">#ESGReporting</p>
                    <p className="text-xs text-slate-600">128 posts this week</p>
                  </div>
                  <div className="text-sm">
                    <p className="font-medium text-emerald-600">#GreenFinance</p>
                    <p className="text-xs text-slate-600">98 posts this week</p>
                  </div>
                  <div className="text-sm">
                    <p className="font-medium text-emerald-600">#RenewableEnergy</p>
                    <p className="text-xs text-slate-600">87 posts this week</p>
                  </div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>

      {/* User Profile Modal */}
      {selectedUserProfile && (
        <div
          data-testid="profile-modal"
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          onClick={() => setSelectedUserProfile(null)}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="relative">
              <div className="h-24 bg-gradient-to-r from-emerald-500 to-emerald-600"></div>
              <button
                data-testid="close-modal-button"
                onClick={() => setSelectedUserProfile(null)}
                className="absolute top-4 right-4 p-2 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full transition-colors"
              >
                <X className="w-5 h-5 text-white" />
              </button>
              <img
                src={selectedUserProfile.avatar}
                alt={selectedUserProfile.name}
                className="w-24 h-24 rounded-full border-4 border-white absolute -bottom-12 left-6"
              />
            </div>

            {/* Modal Content */}
            <div className="pt-16 px-6 pb-6">
              <h2 className="text-2xl font-bold text-slate-900 mb-1">{selectedUserProfile.name}</h2>
              <p className="text-slate-600 mb-4">{selectedUserProfile.role}</p>

              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <Briefcase className="w-5 h-5 text-slate-400 mt-0.5" />
                  <div>
                    <p className="text-sm font-medium text-slate-700">Organization</p>
                    <p className="text-slate-900">{selectedUserProfile.company}</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <MapPin className="w-5 h-5 text-slate-400 mt-0.5" />
                  <div>
                    <p className="text-sm font-medium text-slate-700">Industry Sector</p>
                    <p className="text-slate-900">{selectedUserProfile.sector}</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <TrendingUp className="w-5 h-5 text-slate-400 mt-0.5" />
                  <div>
                    <p className="text-sm font-medium text-slate-700">Focus Area of Expertise</p>
                    <p className="text-slate-900">{selectedUserProfile.expertise}</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <Linkedin className="w-5 h-5 text-slate-400 mt-0.5" />
                  <div>
                    <p className="text-sm font-medium text-slate-700">LinkedIn Profile</p>
                    <a
                      href={selectedUserProfile.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-emerald-600 hover:text-emerald-700 hover:underline"
                    >
                      View Profile
                    </a>
                  </div>
                </div>
              </div>

              <button
                className="w-full mt-6 px-6 py-3 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-lg transition-colors"
              >
                Connect
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
